import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { processReq } from "../../helpers/processRequest";
import { GET, POST, PUT } from "../../utils/requestActionConstants";
import { API_ROUTE } from "../../utils/commonConstants";

const init = {
    product: {},
    productList: [],
    loading: {},
    error: null
};

export const productSlice = createSlice({
    name: "productSlice",
    initialState: init,
    reducers: {
        setProduct: (state, action) => {
            state.product = action.payload;
        },

        setProductsList: (state, action) => {
            state.productList = action.payload;
        },

        clearData: (state) => {
            return init;
        },
    },
    extraReducers: (builder) => {
        builder
        // Fetch product list
        .addCase(fetchProductList.pending, (state) => {
            state.loading.fetching = true;
            state.error = null;
        })
        .addCase(fetchProductList.fulfilled, (state, action) => {
            state.loading.fetching = false;
            state.productList = action.payload;
        })
        .addCase(fetchProductList.rejected, (state, action) => {
            state.loading.fetching = false;
            state.error = action.payload;
        })

        // Add product
        .addCase(addProduct.pending, (state) => {
            state.loading.saving = true;
            state.error = null;
        })
        .addCase(addProduct.fulfilled, (state, action) => {
            state.loading.saving = false;
            state.product = action.payload;
        })
        .addCase(addProduct.rejected, (state, action) => {
            state.loading.saving = false;
            state.error = action.payload;
        })

        // Update product
        .addCase(updateProduct.pending, (state) => {
            state.loading.saving = true;
            state.error = null;
        })
        .addCase(updateProduct.fulfilled, (state, action) => {
            state.loading.saving = false;
            state.product = action.payload;
        })
        .addCase(updateProduct.rejected, (state, action) => {
            state.loading.saving = false;
            state.error = action.payload;
        });
    }
});

export const fetchProductList = createAsyncThunk(
    "productSlice/fetchProductList",
    async (_, { rejectWithValue }) => {
        try {
            const response = await processReq(GET, `${API_ROUTE}/products`);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || "Failed to fetch product list");
        }
    }
);

export const updateProduct = createAsyncThunk(
    "productSlice/updateProduct",
    async ({ productId, productData }, { rejectWithValue, dispatch }) => {
        try {
            const response = await processReq(PUT, `${API_ROUTE}/products/${productId}`, productData);

            dispatch(fetchProductList());

            return response.product;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || "Failed to update product");
        }
    }
);

export const addProduct = createAsyncThunk(
    "productSlice/addProduct",
    async ({ productData }, { rejectWithValue, dispatch }) => {
        try {
            const response = await processReq(POST, `${API_ROUTE}/products`, productData);
            
            dispatch(fetchProductList());

            return response.product;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || "Failed to add product");
        }
    }
);

export const { clearData, setProduct, setProductsList } = productSlice.actions;

export default productSlice.reducer;
